import loadingGif from "../assets/images/loading.gif";

export const Loading = ({ progress }) => {
  return (
    <div
      className="loading-container"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={loadingGif} alt="loading" />
      {progress !== undefined && (
        <h4
          style={{
            marginTop: "15px",
            fontWeight: "bold",
            letterSpacing: "1px",
            color: "inherit",
          }}
        >
          Loading Data... {progress}%
        </h4>
      )}
    </div>
  );
};
